import { gql } from "@apollo/client";
import CHECKOUT_FRAGMENT from "@/fragments/checkout";

const REMOVE_ITEM_FROM_CART = gql`
	${CHECKOUT_FRAGMENT}
	mutation RemoveItemFromCheckout(
		$retailerId: ID!
		$checkoutId: ID!
		$itemId: ID!
	) {
		removeItem(
			retailerId: $retailerId
			checkoutId: $checkoutId
			itemId: $itemId
		) {
			...checkoutFragment
		}
	}
`;
export default REMOVE_ITEM_FROM_CART;